<template>
  <b-modal
    id="scholar-ask"
    no-close-on-backdrop
    centered
    hide-footer
    title="Scholarship Ask"
  >
    <div class="ask-to-sell">
      <b-card no-body class="box-ask-price">
        <b-card-body>
          <b-form>
            <b-form-group :label="`Rate: ${rate}%`" label-for="id-rate">
              <b-form-input
                id="id-rate"
                class="rate-qty"
                v-model="rate"
                type="range"
                min="0"
                max="100"
              ></b-form-input>
            </b-form-group>

            <div v-if="!loadingData" class="w-100 d-flex justify-content-end">
              <b-btn
                @click="nftApprove()"
                v-if="!isNFTApproved"
                class="btn-custom btn-approve mr-2"
              >
                Approve NFT
                <b-icon
                  icon="info-circle-fill"
                  v-b-tooltip.hover.top="
                    'Allow the market to use your non-fungible token'
                  "
                ></b-icon>
              </b-btn>
              <b-btn
                class="btn-custom btn-ask-to-sell"
                :disabled="isDisabled"
                @click="onSave()"
              >
                Ask To Scholarship
              </b-btn>
            </div>
            <b-skeleton v-else type="button"></b-skeleton>
          </b-form>
        </b-card-body>
      </b-card>
    </div>
  </b-modal>
</template>
<script>
import { Scholarship, NFT } from "@/amakunicom/sdk";

export default {
  name: "ScholarshipAsk",
  data: () => ({
    ftLink: "",
    nft: "",
    rate: 50,
    tokenId: 0,
    isNFTApproved: false,
    isNative: false,
    isDisabled: true,
    loadingData: true,
  }),
  created: async function () {
    this.tokenId = this.$route.params.id;
    this.tokens = this.getCoreConfig();
    let { nft, scholarship } = this.tokens;

    this.signer = await this.provider.getSigner();
    this.address = await this.signer.getAddress();

    this.nft = await NFT.initWith(nft, this.provider, this.signer);
    this.scholarship = await Scholarship.initWith(
      scholarship,
      this.provider,
      this.signer
    );

    this.isNFTApproved = await this.nft.isApprovedForAll(
      this.address,
      scholarship
    );
    this.isDisabled = !this.isNFTApproved;
    this.loadingData = false;
  },
  methods: {
    async nftApprove() {
      let tx = await this.market.setApprovalForAll(this.marketAddress, true);
      this.isNFTApproved = true;
      this.$bvToast.show("tx-confirm");
      await tx.wait();
      this.$bvToast.show("tx-success");
      this.$bvToast.hide("tx-confirm");
      this.isDisabled = !this.isNFTApproved;
    },
    async onSave() {
      try {
        this.isDisabled = true;
        const tx = await this.scholarship.ask(
          this.tokens.kuniSaru,
          this.address,
          [this.tokenId],
          this.rate * 100
        );
        this.$bvToast.show("tx-confirm");
        await tx.wait();
        this.$bvToast.show("tx-success");
        this.$bvToast.hide("tx-confirm");
        this.$emit("scholar-success");
      } catch (e) {
        this.$bvToast.hide("tx-confirm");
        this.$bvToast.show("tx-error");
        this.isDisabled = false;
      }
    },
  },
};
</script>
<style lang="scss">
.ask-to-sell {
  .card {
    background: transparent;
  }
  .box-ask-price {
    background-color: transparent;
    border-color: #434343;
    label {
      color: #fff;
      text-transform: uppercase;
    }
    .rate-qty {
      height: 0.3rem;
      -webkit-appearance: none;
      outline: none;
      -webkit-transition: 0.2s;
      transition: opacity 0.2s;
      &::-webkit-slider-runnable-track {
        height: 2px;
        background-color: #b61751;
      }
      &::-webkit-slider-thumb {
        border-radius: 50%;
        background: rgb(235, 52, 95);
        cursor: pointer;
        margin-top: -7px;
      }
      &::-moz-range-thumb {
        border-radius: 50%;
        background: rgb(235, 52, 95);
        cursor: pointer;
      }
    }
    #price {
      height: 56px;
      border-radius: 8px;
      border: 1px solid #434343;
      background-color: transparent;
      color: #fff;
    }
    .balance {
      font-size: 14px;
      color: #898989;
      font-weight: 600;
      margin-top: 10px;
      justify-content: end;
    }
  }
  .nft-title {
    font-size: 30px;
    font-weight: 700;
  }
}
</style>
